// extracted by mini-css-extract-plugin
export default {"product":"rQJaTD","list":"PWCGmB"};